import React, { useState } from 'react';
import { Typography, Box, Button as MuiButton, TextField } from '@mui/material';
import { Modal } from '../../../components';
import {
  useDispatch,
  useSelector,
  saleSlice,
  fetchSaleIrregularitiesReceipt,
} from '../../../stores';
import { useWorker } from '@koale/useworker';
import {
  exportIrregularitiesReceiptToPDF,
  handleApiDataIrregularitiesReceiptToPDF,
} from '../table/exports';

export const SaleIrregularitiesReceiptConfirmationModal: React.FC = () => {
  const dispatch = useDispatch();
  const { saleIrregularitiesReceiptConfirmationModalIsOpen, saleInfo } =
    useSelector((state) => state.saleReducer);
  const { id } = useSelector((state) => state.authReducer);
  const [recipientName, setRecipientName] = useState('');
  const [exportIrregularitiesReceiptToPDFWorker] = useWorker(
    handleApiDataIrregularitiesReceiptToPDF,
  );

  const handleConfirm = () => {
    if (recipientName.trim() && saleInfo?.id && id) {
      // Close confirmation modal
      dispatch(
        saleSlice.actions.toggleSaleIrregularitiesReceiptConfirmationModalIsOpen(),
      );

      // Start the export process
      dispatch(
        fetchSaleIrregularitiesReceipt({
          userId: id.toString(),
          serviceOrderId: saleInfo.id,
        }),
      ).then((res: any) => {
        if (res.payload && res.payload.data && res.payload.data.length > 0) {
          exportIrregularitiesReceiptToPDF(
            res.payload.data,
            dispatch,
            exportIrregularitiesReceiptToPDFWorker,
            recipientName.trim(), // Use the entered name instead of driverName
          ).then(() => {
            dispatch(
              saleSlice.actions.toggleSaleIrregularitiesReceiptExportModalIsOpen(),
            );
          });
        } else {
          dispatch(
            saleSlice.actions.toggleSaleIrregularitiesReceiptExportModalIsOpen(),
          );
        }
      });
    }
  };

  const handleCancel = () => {
    setRecipientName('');
    dispatch(
      saleSlice.actions.toggleSaleIrregularitiesReceiptConfirmationModalIsOpen(),
    );
  };

  return (
    <Modal
      open={saleIrregularitiesReceiptConfirmationModalIsOpen}
      onClose={handleCancel}
      title='Confirmar geração de recibos'
    >
      <Box sx={{ p: 2 }}>
        <TextField
          fullWidth
          label='Nome do destinatário'
          value={recipientName}
          onChange={(e) => setRecipientName(e.target.value)}
          variant='outlined'
          sx={{ mb: 3 }}
          autoFocus
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              handleConfirm();
            }
          }}
        />

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
          <MuiButton variant='outlined' onClick={handleCancel}>
            Cancelar
          </MuiButton>
          <MuiButton
            variant='contained'
            onClick={handleConfirm}
            disabled={!recipientName.trim()}
          >
            Confirmar
          </MuiButton>
        </Box>
      </Box>
    </Modal>
  );
};
